import React from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import './TagsAutocomplete.scss';


const RemoveComponent = (props: any) => {
    const { className, onRemove } = props;
    return (
        <button onClick={onRemove} className={className}>
            <i className="fa fa-times-thin" aria-hidden="true"></i>
        </button>
    )
}

const TagsAutocomplete = ({
  tags = [],
  // className='antTagsInput',
  suggestions=[],
  statusMsg='',
  handleDelete = () => {},
  handleAddition = () => {},
  onChangeEvent = () => {},
  handleInputBlur = () => {},
  minQueryLength = 1,
  clearAll = false,
  onClearAll = () => {},
  renderSuggestion = () => { },
    placeholder='',
   
}:any) => {

  const KeyCodes = {
    comma: 188,
    enter: 13
  };

      
    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const handleFilterSuggestions = (textInputValue:any, possibleSuggestionsArray:any) => {
        const lowerCaseQuery = textInputValue.toLowerCase()
        return possibleSuggestionsArray.filter(function (suggestion :any) {
            return (suggestion.id.toLowerCase().includes(lowerCaseQuery) || 
                suggestion.text.toLowerCase().includes(lowerCaseQuery)
            || suggestion?.id == "")
        })
    }

  return (
    <>
      <ReactTags
              tags={tags}
              renderSuggestion={renderSuggestion}
              suggestions={suggestions}
              delimiters={delimiters}
              handleDelete={handleDelete}
              handleAddition={handleAddition}
              autocomplete
              inputProps={{
                  autocomplete: "nope"
              }}
              inputFieldPosition="bottom"
              handleInputChange={onChangeEvent}
              handleInputBlur={handleInputBlur}
              placeholder={placeholder}
              allowDragDrop={false}
              minQueryLength={minQueryLength}
              clearAll={clearAll}
              onClearAll={onClearAll}
              allowAdditionFromPaste={false}
              removeComponent={RemoveComponent}
              handleFilterSuggestions={handleFilterSuggestions}
      />
      {
        statusMsg && <p  className='mandatoryMsg'>{statusMsg }</p>
      }
    </>
  );
};
  
export default TagsAutocomplete;